import React from "react";

export default function HDIWCommon({ src, title, desc }) {
  return (
    <div className="w-[100%]  lg:flex gap-[20px] bg-gray-0 bg-clip-padding backdrop-filter backdrop-blur-[8px] bg-opacity-10 custom-border-box corner-gradient ">
      <div>
        <img src={src} alt="Shop Images" className="p-5 relative z-20" />
      </div>
      <div className="flex flex-col justify-around">
        <div className="flex flex-col md:flex-row justify-center items-center">
          <h1 className="text-[36px] text-center text-white font-[600]">
            {title}
          </h1>
        </div>
        <p className="text-[18px] md:text-[24px] text-white text-justify">
          {desc}
        </p>
      </div>
      <div className="bottom-left-border"></div>
      <div className="left-vertical-border"></div>
    </div>
  );
}
